import { api } from "@/lib/api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

// Request permission, subscribe to Web Push, and register the subscription on the backend.
export async function enablePush() {
  if (!pushSupported()) return { ok: false, reason: "unsupported" };
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") return { ok: false, reason: "denied" };

    const { data } = await api.get("/push/vapid-public-key");
    if (!data.enabled || !data.publicKey) return { ok: false, reason: "server-disabled" };

    const reg = await navigator.serviceWorker.ready;
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.publicKey),
      });
    }

    const json = sub.toJSON();
    await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
    return { ok: true };
  } catch (e) {
    return { ok: false, reason: "subscribe-failed", error: String(e && e.message ? e.message : e) };
  }
}

// Clear the red badge on the app icon (call when the admin opens/focuses the panel).
export async function clearAppBadge() {
  try {
    if (navigator.clearAppBadge) await navigator.clearAppBadge();
    const reg = await navigator.serviceWorker?.ready;
    if (window.caches) await (await caches.open("cap-meta")).put("/__badge-count", new Response("0"));
    const notifs = (await reg?.getNotifications?.()) || [];
    notifs.forEach((n) => n.close());
  } catch (_) { /* no-op */ }
}

export async function currentEndpoint() {
  try {
    if (!pushSupported()) return null;
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    return sub ? sub.endpoint : null;
  } catch (_) { return null; }
}

export function deviceKind() {
  const ua = navigator.userAgent;
  if (/iPhone|iPad|iPod/.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) return "ios";
  if (/Android/.test(ua)) return "android";
  return "desktop";
}

export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
